import { ShaderModule, UniformTypes } from '@luma.gl/shadertools';

// Caution: order matters !!!
const uniformBlock = `\
uniform feParticleUniforms {
    uniform bool viewportGlobe;
    uniform vec2 viewportGlobeCenter;
    uniform float viewportGlobeRadius;
    uniform vec4 viewportBounds;
    uniform float viewportZoomChangeFactor;
    uniform vec2 imageUnscale;
    uniform vec4 bounds;
    uniform float numParticles;
    uniform float maxAge;
    uniform float speedFactor;
    uniform float time;
    uniform float seed;
} feParticle;
`;

export type ParticleLayerUniforms = {
    viewportGlobe: boolean;
    viewportGlobeCenter: [number, number];
    viewportGlobeRadius: number;
    viewportBounds: [number, number, number, number];
    viewportZoomChangeFactor: number;
    imageUnscale: [number, number];
    bounds: [number, number, number, number];
    numParticles: number;
    maxAge: number;
    speedFactor: number;
    time: number;
    seed: number;
};

export const particleLayerUniforms = {
    name: 'feParticle',
    vs: uniformBlock,
    uniformTypes: {
        viewportGlobe: 'f32',
        viewportGlobeCenter: 'vec2<f32>',
        viewportGlobeRadius: 'f32',
        viewportBounds: 'vec4<f32>',
        viewportZoomChangeFactor: 'f32',
        imageUnscale: 'vec2<f32>',
        bounds: 'vec4<f32>',
        numParticles: 'f32',
        maxAge: 'f32',
        speedFactor: 'f32',
        time: 'f32',
        seed: 'f32'
    } as const satisfies UniformTypes<Required<ParticleLayerUniforms>>
} as const satisfies ShaderModule<ParticleLayerUniforms>;
